export const TWITTER_LOGIN_INIT = {
  LOADING: 'twitterLoginInitLoading',
  SUCCESS: 'twitterLoginInitSuccess',
  FAIL: 'twitterLoginInitFail',
};

export const UPDATE_FIRST_LOGIN = {
  LOADING: 'updateFirstLoginLoading',
  SUCCESS: 'updateFirstLoginSuccess',
  FAIL: 'updateFirstLoginFail',
};
